// extracted by mini-css-extract-plugin
export default {"overlay":"Modal_overlay__b+zEz","modal":"Modal_modal__yEgVW","keyframe-fade-in":"Modal_keyframe-fade-in__iX2Ug"};